// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hrGIj","summary":"styles_summary__wcDTa","details":"styles_details__J27_I","p":"styles_p__mJr8a","text":"styles_text__VvX73","h4":"styles_h4__lHIx2"};